/* eslint-disable @next/next/no-img-element */
import { Alert, Snackbar } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useContext, useEffect, useRef, useState } from 'react';
import { useQueryClient } from 'react-query';
import { putFolderAvatar } from '../../../apis/tms/folder.api';
import { handleSubmitForm } from '../../../common/formCallApi';
import { FOLDER_INFO, GROUP_ROLE_ACCESS } from '../../../constant/QueryKeyName';
import { imgAcceptTypeUpload } from '../../../constant/fileType';
import { ROLE_ACCESS } from '../../../constant/storage';
import AuthContext from '../../../state/auth/AuthContext';

const GroupAvatar: React.FunctionComponent = () => {
  const { setLoading } = useContext(AuthContext);
  const router = useRouter();
  const queryClient = useQueryClient();
  const [folderId, setFolderId] = useState<string>('');
  const [selectedAvatar, setSelectedAvatar] = useState<any>(undefined);
  const [previewAvatar, setPreviewAvatar] = useState<string | undefined>(
    undefined
  );
  const [openToast, setOpenToast] = useState<{
    type: 'success' | 'error';
    content: string;
  }>({
    type: 'success',
    content: '',
  });
  const uploadImageRef = useRef<HTMLInputElement>(null);
  const folder: any = queryClient.getQueryData([FOLDER_INFO, folderId]);
  const mineRole = queryClient.getQueryData([GROUP_ROLE_ACCESS, folderId]);
  const toast = (content: string, type: 'success' | 'error' = 'success') => {
    setOpenToast({ type, content });
  };
  const onSelectAvatar = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedAvatar(undefined);
      toast('Có lỗi xảy ra, vui lòng thử lại.');
      return;
    }
    const file = e.target.files?.item(0);
    if (!file) {
      toast('Có lỗi xảy ra, vui lòng thử lại.');
      return;
    }

    handleSubmitForm({
      callback: () => {},
      data: {
        fileAvatar: file,
      },
      id: folderId || '',
      asyncFunc: putFolderAvatar,
      formCancelCallBack: () => {},
      toggleSuccessModalNoti: () => {
        setSelectedAvatar(file);
        queryClient.refetchQueries([FOLDER_INFO, folderId]);
        toast('Cập nhật thông tin thành công');
      },
      toggleErrorModalNoti: () => toast('Có lỗi xảy ra, vui lòng thử lại.'),
      setLoading,
    });
  };
  useEffect(() => {
    if (router.isReady) {
      setFolderId(router.query?.gid as string);
    }
  }, [router]);
  useEffect(() => {
    if (!selectedAvatar) {
      setPreviewAvatar(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedAvatar);
    setPreviewAvatar(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedAvatar]);
  return (
    <>
      <input
        ref={uploadImageRef}
        type="file"
        className="hidden"
        onChange={onSelectAvatar}
        accept={imgAcceptTypeUpload.join(', ')}
      />
      <div className="absolute z-[9]  bottom-0 left-5 md:left-10">
        <div className="relative">
          <div className="rounded-full overflow-hidden object-cover bg-white">
            <img
              src={
                folder?.avatar ||
                (previewAvatar
                  ? previewAvatar
                  : '/icons/default-group-avatar.svg')
              }
              alt="default-group-avatar"
              className="lg:w-[164px] lg:h-[164px] w-[128px] h-[128px] object-cover"
            />
          </div>
          {mineRole === ROLE_ACCESS.Owner && (
            <div
              className="absolute bottom-0 right-0 rounded-full bg-[#4B4B4B] w-8 h-8 flex items-center justify-center cursor-pointer overflow-hidden"
              onClick={() => {
                uploadImageRef?.current?.click();
              }}
            >
              <Image
                src="/icons/camera-icon.svg"
                alt="camera-icon"
                height={24}
                width={24}
              />
            </div>
          )}
        </div>
      </div>{' '}
      <Snackbar
        autoHideDuration={1500}
        disableWindowBlurListener
        open={!!openToast.content}
        onClose={() => toast('')}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        className="bg-black/75 rounded-md p-4"
      >
        <div>
          {openToast.type === 'success' ? (
            <p className="text-white">{openToast.content}</p>
          ) : (
            <Alert severity="error">{openToast.content}</Alert>
          )}
        </div>
      </Snackbar>
    </>
  );
};

export default GroupAvatar;
